<template>
  <div class="wrapper">
    <p class="tips">
      <span>剩余发票：</span>
      <span>专票{{blankInvoiceCount.specialInvQuantity}}张 </span>
      <span>普票{{blankInvoiceCount.generalInvQuantity}}张 </span>
      <span>电子专票{{blankInvoiceCount.electronicSpecialInvQuantity}}张 </span>
      <span>电子普票{{blankInvoiceCount.electronicInvQuantity}}张 </span>
    </p>
  </div>
</template>

<script>
import { invoiceRequest } from '@services'
import { localStorage } from '@utils/basicUtil'
export default {
  components: {},
  props: {},
  data () {
    return {
      blankInvoiceCount: {}
    }
  },
  computed: {
    invoiceType () {
      const invoiceLimits = localStorage.get('invoiceLimits') || ''
      return invoiceLimits.split(',')
    }
  },
  watch: {},
  created () {},
  mounted () {
    this.getBlankList()
    // Observer.setFunction({ type: 'changeCompany', fn: this.getBlankList })
  },
  activated () {
  },
  updated () {
  },
  methods: {
    async getBlankList () {
      const result = await invoiceRequest.statistics.getStatistics({})
      if (result.success) {
        if (result.result) {
          this.blankInvoiceCount = result.result.blankInvoiceCount || {}
        } else {

        }
      }
    }
  }
}
</script>
<style scoped lang='less'>
  .wrapper{
    background: #3378FF;
    font-size: 18px;
    color: #fff;
    padding: 0 2% 10px;
    .tips{
      opacity: .8;
    }
  }
</style>
